.modal-container {
    z-index: 10000;
    visibility: hidden;
    transition: all 0.3s ease-in-out, visibility 0.3s linear;
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    &.is-open {
        visibility: visible;
        background: rgba(0, 0, 0, 0.5);
    }
}

.rsm-popup-popup-wrapper {
    position: relative;
    border-radius: 8px;
    width: 90%;
    margin: 0 auto;
    max-width: 500px;
    min-height: 30vh;
    max-height: 80vh;
    background: white;
    margin-top: auto;
    margin-bottom: auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1);

    @media (min-width: 640px) {
        min-height: 50vh;
        max-height: 70vh;
    }
}

.rsm-popup-message-modal-container {
    background: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 3rem;
    gap: 1rem;
    justify-content: space-between;
    margin-top: 1rem;

    @media (min-width: 768px) {
        padding: 2rem;
        gap: 1.5rem;
    }
}

.rsm-popup-modal-body {
    flex: 1;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding:0 1rem;

    @media (min-width: 640px) {
        padding: 1rem;
    }
}

.rsm-popup-message-modal-message {
    font-family: inherit;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 2rem;
    padding: 0 1rem;

    @media (min-width: 640px) {
        font-size: 18px;
        margin: 3rem 0;
    }

    @media (min-width: 768px) {
        .rsm-popup-message-modal-message 
        {
            font-size: 20px;
            padding: 0 2rem;
        }
    }

    @media (min-width: 1024px) 
    {
        font-size: 1.375rem;
    }
}

.rsm-popup-modal-buttons {
    border-top: 2px solid #e5e7eb;
    padding: 1rem 0 0;

    @media (min-width: 768px) {
        padding: 1.5rem 0 0;
    }
}

.rsm-popup-modal-footer {
    width: 100%;
    min-width: 280px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-shrink: 0;

    @media (max-width: 480px){
        max-width: 100%;
    }

    @media (min-width: 640px) {
        .rsm-popup-modal-footer {
            min-width: 250px;
            padding: 1rem;
        }
    }
}